import * as yup from "yup";

export const validationSchema = yup.object().shape({
  email: yup.string().email("fieldRequired").max(100).required("fieldRequired"),
  last_name: yup.string().max(50).required("fieldRequired"),
  first_name: yup.string().max(50).required("fieldRequired"),
  mobile: yup
    .string()
    .when("select", (select, schema) => {
      if (select[0]?.value === "852") {
        return schema
          .required("*fieldRequired")
          .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
          .length(8, "*fieldRequired");
      } else if (select[0]?.value === "853") {
        return schema
          .matches(/^[6][0-9]{7}$/, "fieldRequired")
          .length(8, "*fieldRequired")
          .required("*fieldRequired");
      } else if (select[0]?.value === "86") {
        return schema
          .matches(/^[1][0-9]{10}$/, "fieldRequired")
          .length(11, "fieldRequired")
          .required("fieldRequired");
      }
      return schema;
    })
    .required("fieldRequired"),
  consent: yup.boolean().oneOf([true], "fieldRequired"),
  // tnc: yup.boolean().oneOf([true], "fieldRequired"),
  // tnc2: yup.boolean().oneOf([true], "fieldRequired"),
  // signatureImageUrl: yup
  //   .string()
  //   .required("fieldRequired")
  //   .matches(
  //     /^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/,
  //     "fieldRequired"
  //   )
  //   .test("fileSize", "File Size is too large", (value) => {

  //     return value && value?.length <= 300000;
  //   }),
});

export const ImeiValidationSchema = yup.object().shape({
  imei: yup
    .array()
    .of(
      yup.object().shape({
        value: yup
          .string()
          .min(11, "The IMEI must be at least 11 characters")
          .required("fieldRequired"),
      })
    )
    .required("At least one IMEI is required")
    .min(1, "At least one IMEI is required"),
});

export const AccessCodeValidationSchema = yup.object().shape({
  access_code: yup
    .mixed()
    .oneOf(
      [
        "3331",
        "3332",
        "3333",
        "3334",
        "3335",
        "3336",
        "3337",
        "3338",
        "3339",
        "3310",
        "3311",
      ],
      "fieldRequired"
    ),
});

export const MobileNumberValidationSchema = yup.object().shape({
  mobile_number: yup
    .string()
    .when("select", (select, schema) => {
      if (select[0]?.value === "852") {
        return schema
          .required("fieldRequired")
          .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired");
      } else if (select[0]?.value === "853") {
        return schema
          .matches(/^[6][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired")
          .required("fieldRequired");
      } else if (select[0]?.value === "86") {
        return schema
          .matches(/^[1][0-9]{10}$/, "fieldRequired")
          .length(11, "fieldRequired")
          .required("fieldRequired");
      }
      return schema;
    })
    .required("fieldRequired"),
});

export const GameValidationSchema = yup.object().shape({
  answer: yup.string().max(3).required("fieldRequired"),
});

export const OtpValidationSchema = yup.object().shape({
  otp: yup.string().min(6).max(6).required("fieldRequired"),
});

export const FormValidationSchema = yup.object().shape({
  email: yup.string().email("fieldRequired").max(100).required("fieldRequired"),
  last_name: yup.string().max(50).required("fieldRequired"),
  first_name: yup.string().max(50).required("fieldRequired"),
  mobile_number: yup
    .string()
    .when("select", (select, schema) => {
      if (select[0]?.value === "852") {
        return schema
          .required("fieldRequired")
          .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired");
      } else if (select[0]?.value === "853") {
        return schema
          .matches(/^[6][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired")
          .required("fieldRequired");
      } else if (select[0]?.value === "86") {
        return schema
          .matches(/^[1][0-9]{10}$/, "fieldRequired")
          .length(11, "fieldRequired")
          .required("fieldRequired");
      }
      return schema;
    })
    .required("fieldRequired"),
  hkid: yup.string().length(4, "fieldRequired"),
  tnc: yup.boolean().oneOf([true], "fieldRequired"),
  privacy_policy: yup.boolean().oneOf([true], "fieldRequired"),
});
